<script lang="ts" setup>
import { useDisplay } from 'vuetify'
import ElevatedBlockBtn from '../ui-elements/buttons/ElevatedBlockBtn.vue'
import ElevatedBtn from '../ui-elements/buttons/ElevatedBtn.vue'
import OutlinedBlockBtn from '../ui-elements/buttons/OutlinedBlockBtn.vue'
import OutlinedBtn from '../ui-elements/buttons/OutlinedBtn.vue'
import AlertPopupWindowCopy from './AlertPopupWindow.vue'

const { activator } = defineProps<{ activator: boolean }>()
const emit = defineEmits(['continue', 'cancel', 'close'])

const { mobile } = useDisplay()
</script>
<template>
  <AlertPopupWindowCopy
    :activator="activator"
    @close="emit('close')"
    @after-leave="() => {}"
    :display-do-not-show-again-input="false"
  >
    <v-card flat :max-width="mobile ? undefined : '70%'">
      <v-card-title class="text-center pt-0 pb-8 font-weight-bold">
        This may break your trip...
      </v-card-title>
      <v-card-text class="text-center">
        These changes to your itinerary might break your current trip. Make sure to save this trip
        first before replanning.
      </v-card-text>
      <v-card-actions v-if="mobile" class="flex-column align-start justify-center pt-5">
        <ElevatedBlockBtn @click="emit('continue')"> Continue </ElevatedBlockBtn>
        <OutlinedBlockBtn shape="box" @click="emit('close')"> Cancel </OutlinedBlockBtn>
      </v-card-actions>
      <v-card-actions v-else class="justify-center pt-5">
        <OutlinedBtn @click="emit('close')" class="mr-2"> Cancel </OutlinedBtn>
        <ElevatedBtn @click="emit('continue')" class="ml-2"> Continue </ElevatedBtn>
      </v-card-actions>
    </v-card>
  </AlertPopupWindowCopy>
</template>
